// extracted by mini-css-extract-plugin
export default {"productGallery":"YF-z","inQuickShop":"ZF-z"};